import { Box } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { GetCompanyExtDataQuery } from "components/gql/queris/GetCompanyExtData";
import {
  getCompanyStyle,
  isIdentical,
  isValidToken,
  joinParams,
  saveParseJson,
  setLocalStorageItem,
} from "data/functions";
import { isObjectEmpty } from "data/functions";
import { actions } from "data/globals";
import React, { useEffect, useState } from "react";
// import { Helmet } from "react-helmet";
import { Helmet, HelmetProvider } from "react-helmet-async";
// import { useAuth } from "react-oidc-context";
import { GetData } from "./DataContext";

export const CompanyContext = React.createContext();

export const reducer = (state, action) => {
  switch (action.type) {
    case actions.pushArray: {
      let stateValue = state?.cInfo[action.paramName];
      let newValue = joinParams(stateValue, action.paramValue, action.defType);

      if (!isIdentical(stateValue, newValue)) {
        setLocalStorageItem("company_" + action.paramName, newValue);
        return {
          ...state,
          cInfo: {
            ...state.cInfo,
            [action.paramName]: newValue,
          },
        };
      } else return state;
    }

    case actions.setArray: {
      let paramValue = state?.cInfo[action.paramName] || "";
      if (paramValue !== action.paramValue) {
        setLocalStorageItem("company_" + action.paramName, action.paramValue);

        return {
          ...state,
          cInfo: {
            ...state?.cInfo,
            [action.paramName]: action.paramValue,
          },
        };
      } else return state;
    }
    default:
      return state;
  }
};

export const initialState = {
  cInfo: {},
};

export function CheckSize(theme) {
  return useMediaQuery(theme.breakpoints.up("md"), {
    noSsr: true,
  });
}

function CompanyProvider({ children }) {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  // const auth = useAuth();
  const searchParams = new URLSearchParams(window.location.search);
  const [getCompanyExtDataQuery] = GetCompanyExtDataQuery();
  const { dataObj } = GetData();

  const value = {
    cInfo: state.cInfo,

    setCInfo: React.useCallback(
      (value, param) =>
        dispatch({
          paramName: param,
          paramValue: value,
          type: actions.setArray,
        }),
      []
    ),
  };

  React.useEffect(() => {
    for (let i = 0; i < localStorage.length; i++) {
      let key = localStorage.key(i);
      let value = undefined;
      if (key.includes("company_"))
        try {
          value = saveParseJson(localStorage.getItem(key));
          if (!isObjectEmpty(value)) {
            dispatch({
              paramName: key.replace("company_", ""),
              paramValue: value,
              type: actions.setArray,
            });
          }
        } catch {}
    }
  }, []);

  useEffect(() => {
    if (state?.cInfo?.UUID && isValidToken(dataObj?.token))
      getCompanyStyle(state?.cInfo?.UUID, getCompanyExtDataQuery, value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataObj?.token]);

  // const favicon = document.getElementById("favicon");

  // useEffect(() => {
  //   if (
  //     state?.cInfo?.style?.favicon?.url &&
  //     favicon.href !== state?.cInfo?.style?.favicon?.url
  //   ) {
  //     favicon.setAttribute("href", state?.cInfo?.style?.favicon?.url);
  //   }
  // }, [state?.cInfo?.style?.favicon?.url, favicon?.href]);

  return (
    <CompanyContext.Provider value={value}>
      <HelmetProvider>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{"5S PAY"}</title>
        </Helmet>
      </HelmetProvider>

      {children}
    </CompanyContext.Provider>
  );
}
export const GetCInfo = () => {
  const context = React.useContext(CompanyContext);
  return context;
};

export { CompanyProvider };
